import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';

/**
 * TEST ONLY: which tenant's dashboard to show without logging in as it. The API honours the header only
 * when Dashboard:AllowViewAsTenant = true (set for local testing, never in production); otherwise it is ignored
 * and every user sees their own tenant, as always.
 */
@Injectable({ providedIn: 'root' })
export class DashboardViewAsService {
    static readonly header = 'X-Dashboard-View-As';
    private static readonly storageKey = 'd20.viewAsTenant';

    readonly tenantId$ = new BehaviorSubject<number | null>(DashboardViewAsService.read());

    get tenantId(): number | null {
        return this.tenantId$.value;
    }

    set(tenantId: number | null): void {
        try {
            if (tenantId) {
                localStorage.setItem(DashboardViewAsService.storageKey, String(tenantId));
            } else {
                localStorage.removeItem(DashboardViewAsService.storageKey);
            }
        } catch {
            // storage blocked: the choice lasts for this page only
        }
        this.tenantId$.next(tenantId || null);
    }

    private static read(): number | null {
        try {
            const v = Number(localStorage.getItem(DashboardViewAsService.storageKey));
            return v > 0 ? v : null;
        } catch {
            return null;
        }
    }
}

/** Adds the view-as header to the dashboard's own API calls (MerchantDashboard/*) only. */
@Injectable()
export class DashboardViewAsInterceptor implements HttpInterceptor {
    constructor(private _viewAs: DashboardViewAsService) {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const t = this._viewAs.tenantId;
        if (t && req.url.indexOf('/MerchantDashboard/') >= 0 && req.url.indexOf('/GetTestTenants') < 0) {
            req = req.clone({ setHeaders: { [DashboardViewAsService.header]: String(t) } });
        }
        return next.handle(req);
    }
}
